export const FoodData = [
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/1/18682851/b987884c00153d4d234fbe1168174979_o2_featured_v2.jpg',
        time: '43 min',
        title: 'Jhakkas Bombay Pav Bhaji',
        price: 150,
        recentOrder: 1600,
        discount: '50% OFF up to 100',
        proDiscount: '',
        promoted: true,
        address: 'Street Food, Maharashtrian, North Indian, Pizza, Sandwich, Beverages',
        rating: 3.9,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/1/171/50c3ff296839c4f3f3fc27ec583ba4e6_o2_featured_v2.jpg',
        time: '23 min',
        title: "McDonald's",
        price: 150,
        recentOrder: 3575,
        discount: '50% OFF up to 100',
        proDiscount: '',
        promoted: false,
        address: 'Burger, Fast Food, Beverages, Coffee',
        rating: 4.3,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/3/19253173/7aae8602e6092ffaa0a5b70fc7307bf8_o2_featured_v2.jpeg',
        time: '36 min',
        title: 'The Dhaba Junction',
        price: 150,
        recentOrder: 7825,
        discount: '60% OFF',
        proDiscount: 'Pro extra 20% OFF',
        promoted: true,
        address: 'Mughlai, Fast Food, North Indian, Beverages, Chinese',
        rating: 3.5,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/7/147/8aea16d34892cf7fee812b64c19137bd_o2_featured_v2.jpg',
        time: '25 min',
        title: 'Subway',
        price: 150,
        recentOrder: 1400,
        discount: '50% OFF up to 100',
        proDiscount: '',
        promoted: false,
        address: 'Healthy Food, Fast Food, Sandwich, Salad, Wraps, Beverages',
        rating: 3.9,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/8/310078/2a538312f1ff424b4187429cc306060d_o2_featured_v2.jpg',
        time: '30 min',
        title: 'Burger King',
        price: 150,
        recentOrder: 4375,
        discount: '',
        proDiscount: '',
        promoted: false,
        address: 'Burger, Fast Food, Street Food',
        rating: 4.3,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/9/300809/2cb2591d5cd3dde4aaa527c79b60333f_o2_featured_v2.jpg',
        time: '35 min',
        title: 'SGF - Spice Grill Flame',
        price: 150,
        recentOrder: 1800,
        discount: '50% OFF up to 100',
        proDiscount: 'Pro extra 15% OFF',
        promoted: false,
        address: 'North Indian',
        rating: 3.6,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/1/931/c5b93295efeee157ca69c60921d8ce1a_o2_featured_v2.jpg',
        time: '16 min',
        title: 'KFC',
        price: 250,
        recentOrder: 3575,
        discount: '50% OFF up to 100',
        proDiscount: '',
        promoted: false,
        address: 'Burger, Fast Food',
        rating: 4.1,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/1/491/aa50c08ea5ade50a6d1c2d7aca242a1c_o2_featured_v2.jpg',
        time: '28 min',
        title: 'Bikanervala',
        price: 250,
        recentOrder: 1725,
        discount: '50% OFF up to 100',
        proDiscount: '',
        promoted: false,
        address: 'Mithai, North Indian, Chinese, Fast Food, Street Food, Desserts, Beverages',
        rating: 3.8,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/6/246/3f082a046a641c523081cbab51734d9f_o2_featured_v2.jpg',
        time: '38 min',
        title: 'Pizza Hut',
        price: 250,
        recentOrder: 6500,
        discount: 'Free Margherita Pizza',
        proDiscount: '',
        promoted: false,
        address: 'Pizza, Fast Food, Pasta, Beverages, Desserts',
        rating: 3.6,
    },
    {
        img: 'https://b.zmtcdn.com/data/pictures/chains/8/18978968/249c75e2b7b709b3b4af7379345d848d_o2_featured_v2.jpg',
        time: '23 min',
        title: 'Biryani Badshah',
        price: 250,
        recentOrder: 3875,
        discount: '',
        proDiscount: '',
        promoted: false,
        address: 'Biryani, Hyderabadi, Andhra, North Indian, Mughlai',
        rating: 4.0,
    },

]